import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  subtext?: string;
  className?: string;
}
export function CTAButton({
  children,
  subtext,
  className = '',
  ...props
}: CTAButtonProps) {
  return <a href="https://checkout.impulsodigitalx.shop/cart/45711849652385:1" className={`group relative flex flex-col items-center justify-center w-full max-w-2xl mx-auto bg-brand-coral hover:bg-brand-coral-dark text-white border-b-4 border-brand-coral-dark active:border-b-0 active:translate-y-1 rounded-xl p-4 transition-all duration-200 shadow-lg hover:shadow-xl animate-pulse-slow ${className}`} style={{
    textDecoration: 'none'
  }} data-id="element-26">
      <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-black uppercase tracking-wide text-center leading-tight" data-id="element-27">
        {children}
        <ArrowRight className="w-8 h-8 md:w-10 md:h-10 animate-bounce-x" data-id="element-28" />
      </div>
      {subtext && <span className="text-sm md:text-base font-medium opacity-90 mt-1" data-id="element-29">
          {subtext}
        </span>}
      <div className="absolute inset-0 rounded-xl overflow-hidden" data-id="element-30">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shine" data-id="element-31" />
      </div>
    </a>;
}